export default __webpack_public_path__ + "img/fURKNuVS.21f77e14.svg";